(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const initializeTableOfContents = (host) => {
      if (host.dataset.uaTocInitialized === 'true') return;

      const main = document.querySelector('main');
      const content = document.querySelector('[data-ua-article-content]');
      const list = host.querySelector('[data-ua-toc-list]');
      const openButton = host.querySelector('[data-ua-toc-open]');
      const drawer = host.querySelector('[data-ua-toc-drawer]');
      const closeButtons = Array.from(host.querySelectorAll('[data-ua-toc-close]'));

      if (!main || !content || !list || !openButton || !drawer || closeButtons.length === 0) return;

      const headings = Array.from(main.querySelectorAll('h2')).filter((heading) => {
        if (heading.closest('[data-ua-article-toc]')) return false;
        if (heading.closest('.article-template__comment-wrapper')) return false;
        return heading.textContent.trim().length > 0;
      });

      if (headings.length < 2) {
        host.remove();
        return;
      }

      const usedIds = new Set();
      const slugify = (value) => {
        const slug = value
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        return slug || 'section';
      };

      headings.forEach((heading) => {
        let baseId = heading.id || `ua-guide-${slugify(heading.textContent.trim())}`;
        let uniqueId = baseId;
        let suffix = 2;

        while (usedIds.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
          uniqueId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        heading.id = uniqueId;
        usedIds.add(uniqueId);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${uniqueId}`;
        link.textContent = heading.dataset.tocLabel || heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });

      const links = Array.from(list.querySelectorAll('a'));
      let ticking = false;

      const closeDrawer = (returnFocus = true) => {
        host.classList.remove('ua-article-toc-host--open');
        openButton.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.removeProperty('overflow');
        if (returnFocus) openButton.focus();
      };

      const openDrawer = () => {
        host.classList.add('ua-article-toc-host--open');
        openButton.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        drawer.focus();
      };

      openButton.addEventListener('click', openDrawer);
      closeButtons.forEach((button) => button.addEventListener('click', () => closeDrawer()));
      links.forEach((link) => link.addEventListener('click', () => closeDrawer(false)));

      host.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && host.classList.contains('ua-article-toc-host--open')) {
          closeDrawer();
        }
      });

      const update = () => {
        ticking = false;

        const header = document.querySelector('sticky-header, .section-header');
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const tocTop = Math.max(24, headerBottom + 24);
        host.style.setProperty('--ua-toc-top', `${tocTop}px`);

        let activeIndex = 0;
        const activationLine = window.scrollY + tocTop + 24;

        headings.forEach((heading, index) => {
          const headingTop = heading.getBoundingClientRect().top + window.scrollY;
          if (headingTop <= activationLine) activeIndex = index;
        });

        links.forEach((link, index) => {
          if (index === activeIndex) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });

      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      host.dataset.uaTocInitialized = 'true';
      host.classList.add('ua-article-toc-host--ready');
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      requestUpdate();
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-ua-article-toc]').forEach(initializeTableOfContents);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
